import { render, staticRenderFns } from "./LichSuQuangCaoForm.vue?vue&type=template&id=50ee9187&scoped=true"
import script from "./LichSuQuangCaoForm.vue?vue&type=script&lang=js"
export * from "./LichSuQuangCaoForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuQuangCaoForm.vue?vue&type=style&index=0&id=50ee9187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee9187",
  null
  
)

export default component.exports